import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var AnswerCount = styled.div.withConfig({
  displayName: "AnswerCount",
  componentId: "sc-1ubwndg-0"
})(["display:inline-block;min-width:30px;padding:0 3px;border-radius:", ";margin-right:12px;background-color:", ";", ";font-weight:500;color:", ";text-align:center;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme,
    isSolved = _ref2.isSolved;
  return isSolved ? theme.colors.positive : theme.colors.uiLL;
}, getFont(-1), function (_ref3) {
  var theme = _ref3.theme,
    isSolved = _ref3.isSolved;
  return isSolved ? '#fff' : theme.colors.font;
});